var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "crowdfund" }, [
    _c(
      "div",
      { staticClass: "crowdfund-details" },
      [
        _c("h3", [_vm._v(_vm._s(_vm.i18n.sale_corporate_details()))]),
        _vm._v(" "),
        _c("detail-row", {
          attrs: { prop: _vm.i18n.com_name(), value: "" + _vm.syndicate.name }
        }),
        _vm._v(" "),
        _c("detail-row", {
          attrs: {
            prop: _vm.i18n.com_date_of_foundation(),
            value: "" + _vm.syndicate.founded
          }
        }),
        _vm._v(" "),
        _c("detail-row", {
          attrs: {
            prop: _vm.i18n.com_homepage(),
            value:
              "<a href='" +
              _vm.syndicate.homepage +
              "' target='_blank'>" +
              _vm.syndicate.homepage +
              "</a>"
          }
        }),
        _vm._v(" "),
        _c("detail-row", {
          attrs: {
            prop: _vm.i18n.com_industry_tags(),
            value: "" + _vm.syndicate.industry
          }
        }),
        _vm._v(" "),
        _c("detail-row", {
          attrs: {
            prop: _vm.i18n.com_team_size(),
            value: "" + _vm.syndicate.teamSize
          }
        }),
        _vm._v(" "),
        _c("detail-row", {
          attrs: {
            prop: _vm.i18n.com_type(),
            value: "" + _vm.syndicate.company
          }
        }),
        _vm._v(" "),
        _c("detail-row", {
          attrs: {
            prop: _vm.i18n.com_headquarters(),
            value: "" + _vm.syndicate.headquarters
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "crowdfund-team" }, [
      _c("h3", [_vm._v(_vm._s(_vm.i18n.sale_crowdfund_team()))]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "crowdfund-team-list" },
        [
          _vm._l(_vm.syndicate.members, function(item, i) {
            return [
              _c("div", { key: i, staticClass: "crowdfund-team-member" }, [
                _c("img", {
                  staticClass: "crowdfund-team-member-photo",
                  attrs: {
                    src: _vm.getUrl(item),
                    alt: "crowdfund team member photo"
                  }
                }),
                _vm._v(" "),
                _c("h3", { staticClass: "crowdfund-team-member-name" }, [
                  _vm._v(_vm._s(item.name))
                ]),
                _vm._v(" "),
                item.isLeader
                  ? _c("p", [_vm._v(_vm._s(_vm.i18n.sale_crowdfund_leader()))])
                  : _vm._e()
              ])
            ]
          })
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9135cbb8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9135cbb8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/sales/sale_details/tabs/Sales.CrowdfundTab.vue
// module id = TErp
// module chunks = 1